import { render, staticRenderFns } from "./integralGiftDetailManageList.vue?vue&type=template&id=d2f0f0d0&scoped=true"
import script from "./integralGiftDetailManageList.vue?vue&type=script&lang=js"
export * from "./integralGiftDetailManageList.vue?vue&type=script&lang=js"
import style0 from "./integralGiftDetailManageList.vue?vue&type=style&index=0&id=d2f0f0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f0f0d0",
  null
  
)

export default component.exports